/**
 * Sticky Header - Always Fixed (No Jump, No Lag)
 * Calculates header height and sets CSS variable for body padding
 * Header is always position: fixed from the start
 * Header-top hides on scroll down, shows on scroll up
 */

(function () {
  "use strict";

  let lastScrollTop = 0;
  let scrollThreshold = 50; // Minimum scroll distance to trigger hide/show
  let scrollUpDistance = 0; // Track cumulative scroll up distance
  let showHeaderThreshold = 200; // Need to scroll up 40-50px to show header-top

  function updateHeaderHeights() {
    // Try multiple selectors to find the header
    const stickyHeader =
      document.querySelector("header.header-sticky") ||
      document.querySelector("header[data-section='HeaderSection']") ||
      document.querySelector("header.header");
    const sliderBottomHeader = document.querySelector(
      ".slider-bottom-header-sticky"
    );

    if (stickyHeader) {
      // Get header-top and header-bottom separately
      const headerTop =
        stickyHeader.querySelector(":scope > .header-top") ||
        stickyHeader.querySelector(".header-top");
      const headerBottom =
        stickyHeader.querySelector(":scope > .header-bottom") ||
        stickyHeader.querySelector(".header-bottom");

      let totalHeight = 0;
      let headerTopHeight = 0;
      let headerBottomHeight = 0;

      if (headerTop) {
        headerTopHeight = headerTop.offsetHeight;
        document.documentElement.style.setProperty(
          "--header-top-height",
          headerTopHeight + "px"
        );
      }

      if (headerBottom) {
        headerBottomHeight = headerBottom.offsetHeight;
        document.documentElement.style.setProperty(
          "--header-bottom-height",
          headerBottomHeight + "px"
        );
      }

      // Check if header-top is hidden
      const isHeaderTopHidden = stickyHeader.classList.contains("hide-top");

      // Calculate total height based on visibility
      if (isHeaderTopHidden) {
        // Only count header-bottom when header-top is hidden
        totalHeight = headerBottomHeight;
      } else {
        // Count both when header-top is visible
        totalHeight = headerTopHeight + headerBottomHeight;
      }

      // Set the dynamic header height
      document.documentElement.style.setProperty(
        "--header-height",
        totalHeight + "px"
      );
    }

    if (sliderBottomHeader) {
      const sliderBottomHeaderHeight = sliderBottomHeader.offsetHeight;
      document.documentElement.style.setProperty(
        "--slider-bottom-header-height",
        sliderBottomHeaderHeight + "px"
      );
    }
  }

  function handleHeaderTopVisibility() {
    // Try multiple selectors to find the header
    const stickyHeader =
      document.querySelector("header.header-sticky") ||
      document.querySelector("header[data-section='HeaderSection']") ||
      document.querySelector("header.header");
    const sliderBottomHeader = document.querySelector(
      ".slider-bottom-header-sticky"
    );

    const header = stickyHeader || sliderBottomHeader;
    if (!header) return;

    // Use direct child selector to get immediate header-top child
    const headerTop =
      header.querySelector(":scope > .header-top") ||
      header.querySelector(".header-top");

    if (!headerTop) return;

    // If header doesn't have .header-sticky, add it
    if (
      !header.classList.contains("header-sticky") &&
      !header.classList.contains("slider-bottom-header-sticky")
    ) {
      header.classList.add("header-sticky");
    }

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const scrollingDown = scrollTop > lastScrollTop;
          const scrollingUp = scrollTop < lastScrollTop;
          const scrollDelta = Math.abs(scrollTop - lastScrollTop);

          let headerStateChanged = false;

          // At top of page - always show header-top and reset scroll up distance
          if (scrollTop <= scrollThreshold) {
            scrollUpDistance = 0;
            if (header.classList.contains("hide-top")) {
              header.classList.remove("hide-top");
              headerStateChanged = true;
            }
          }
          // Scrolling down - hide header-top and reset scroll up distance
          else if (scrollingDown && scrollTop > scrollThreshold) {
            scrollUpDistance = 0; // Reset when scrolling down
            if (!header.classList.contains("hide-top")) {
              header.classList.add("hide-top");
              headerStateChanged = true;
            }
          }
          // Scrolling up - accumulate distance, show header-top only after threshold
          else if (scrollingUp) {
            scrollUpDistance += scrollDelta;

            // Only show header-top if scrolled up enough (40-50px)
            if (scrollUpDistance >= showHeaderThreshold) {
              if (header.classList.contains("hide-top")) {
                header.classList.remove("hide-top");
                headerStateChanged = true;
                scrollUpDistance = 0; // Reset after showing
              }
            }
          }

          // Update body padding when header state changes
          if (headerStateChanged) {
            updateHeaderHeights();
          }

          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      updateHeaderHeights();
      handleHeaderTopVisibility();
    });
  } else {
    updateHeaderHeights();
    handleHeaderTopVisibility();
  }

  // Update on window resize (e.g., mobile rotation, browser zoom)
  window.addEventListener("resize", updateHeaderHeights);

  // Final update after all resources loaded (images, fonts, etc.)
  window.addEventListener("load", () => {
    setTimeout(updateHeaderHeights, 100);
  });
})();
